export default "__VITE_ASSET__69614b86__"